import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  fetchEvent,
  editEvent,
  deleteEvent,
  deleteEventStage
} from '../actions/event'

import {
  createEventUser,
  deleteEventUser
} from '../actions/event-user'

import {
  deleteRiderRequest
} from '../actions/event-rider-request'

import { setModal } from '../actions/modal'

import Loading from '../components/common/loading'
import NotFound from '../components/common/not-found'

import EventNavigation from '../components/event/event-navigation'
import EventBreadcrumbs from '../components/event/event-breadcrumbs'
import EventRiders from '../components/event/event-riders/riders'
import EventStages from '../components/event/event-stages'

class Event extends Component {
  componentWillMount() {
    const { eventId } = this.props.match.params
    const { event } = this.props

    if (eventId && eventId !== event.id) this.props.fetchEvent(eventId)
  }

  componentWillReceiveProps(nextProps) {
    const { event } = nextProps

    if (event.deletedEventId) this.props.history.replace({pathname: '/library'})
    if (event.createdStageId !== this.props.event.createdStageId) this.props.history.replace({pathname: `/event/${event.id}/stage/${event.createdStageId}`})
    if (event.deletedStageId) this.props.history.replace({pathname: `/event/${event.id}`})
  }

  navigateTo(section) {
    const domElement = this[section] && ReactDOM.findDOMNode(this[section].current)
    const offsetTop = domElement ? domElement.offsetTop : 0

    window.scroll({
      top: offsetTop,
      behavior: 'smooth'
    })
  }

  getStage() {
    const { eventId, stageId } = this.props.match.params
    const { event } = this.props

    if (stageId !== undefined) {
      const stageIndex = event.stages.map(stage => stage.id).indexOf(stageId)

      return event.stages[stageIndex]
    } else {
      return undefined
    }
  }

  render() {
    const { eventId, stageId, section } = this.props.match.params
    const { url } = this.props.match
    const { userSession, event } = this.props

    if (event.error) {
      return <NotFound />
    } else
    if (Object.keys(event).length === 0 || event.createdEventId || event.isFetching === true) return ( // TODO: Check at what stage createdEventId gets replaced
      <Loading
        className="event"
        message="We are loading up your event" />
    )

    const view = {
      loggedIn: userSession.loggedIn,
      editable: event.editable,
      section,
      user: userSession.user // TODO: Setting user inside view a good practice?
    }

    const stage = this.getStage()

    return (
      <div className="event">
        <div className="event-header">
          <EventBreadcrumbs
            view={view}
            event={event}
            stage={stage}
            editEvent={(data) => this.props.editEvent(event.id, data)}
            deleteEvent={() => this.props.deleteEvent(event.id)}
            deleteEventStage={(stageId) => this.props.deleteEventStage(stageId)}
            createEventUser={(user) => this.props.createEventUser(event.id, user)}
            deleteEventUser={(userId) => this.props.deleteEventUser(event.id, userId)} />

          <EventStages
            view={view}
            event={event}
            stage={stage}
            setModal={(name, data) => this.props.setModal(name, {...data, eventId})} />
        </div>

        <div className="event-document">
          <EventNavigation
            url={section ? url.substring(0, url.indexOf(`/${section}`)) : url}
            eventId={eventId}
            navigateTo={(section) => this.navigateTo(section)} />

          <EventRiders
            view={view}
            eventId={event.id}
            stage={stage}
            stages={event.stages}
            deleteRiderRequest={(requestId) => this.props.deleteRiderRequest(requestId)}
            setModal={(name, data) => this.props.setModal(name, {...data, eventId})} />
        </div>
      </div>
    )
  }
}

Event.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  userSession: PropTypes.object,
  event: PropTypes.object,
  fetchEvent: PropTypes.func,
  editEvent: PropTypes.func,
  deleteEvent: PropTypes.func,
  deleteEventStage: PropTypes.func,
  createEventUser: PropTypes.func,
  deleteEventUser: PropTypes.func,
  deleteRiderRequest: PropTypes.func,
  setModal: PropTypes.func
}

Event.defaultProps = {
  match: {},
  location: {},
  history: {},
  userSession: {},
  event: {},
  fetchEvent: function() {},
  editEvent: function() {},
  deleteEvent: function() {},
  deleteEventStage: function() {},
  createEventUser: function() {},
  deleteEventUser: function() {},
  deleteRiderRequest: function() {},
  setModal: function() {}
}

export const mapStateToProps = (state) => {
  return {
    event: state.event
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchEvent,
    editEvent,
    deleteEvent,
    deleteEventStage,
    createEventUser,
    deleteEventUser,
    deleteRiderRequest,
    setModal
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Event)



// WEBPACK FOOTER //
// ./src/containers/event.js